import { isAfter } from 'date-fns';
import {
  Dispatch, SetStateAction, useState,
} from 'react';

const isDate = (date: Date | null) => date instanceof Date;

export type DateFilterRange = {
  rangeOption: number;
  setRangeOption: Dispatch<SetStateAction<number>>;
};

// Finds the first valid date in the array, returning the number of dates that come after it
// (the first date in the array is the primary selected date)
// [2024-02-25, 2024-02-24, 2024-02-26] => 1
const initialSelectedDateRange = (dates: Date[], dateRanges: number[]): number => {
  if (dates.length === 0) {
    return -1;
  }
  let selectedRange = 0;
  const selectedDate = dates.find(isDate);
  if (selectedDate) {
    selectedRange = dates.filter((date) => isAfter(date, selectedDate)).length;
  }
  return dateRanges.includes(selectedRange) ? selectedRange : -1;
};

const useDateFilterRange = (
  dates: Date[],
  dateRanges: number[],
): DateFilterRange => {
  const [rangeOption, setRangeOption] = useState(() => initialSelectedDateRange(dates, dateRanges));

  return {
    rangeOption,
    setRangeOption,
  };
};

export default useDateFilterRange;
